import axios from 'axios';

const sessionCookieName = '__Host-blackout-oauth-csrf';
let csrfToken = null;

function readCookie(name) {
	let prefix = `${name}=`;
	let entry = document.cookie.split(';').map(value => value.trim()).find(value => value.indexOf(prefix) === 0);
	return entry ? decodeURIComponent(entry.slice(prefix.length)) : null;
}

function issuer() {
	let host = window.location.hostname;
	// A locally served rugby-web build is not itself an authorization server.
	// Let an explicit local issuer override it, while the deployed auth host
	// remains same-origin so its HttpOnly browser session is never sent elsewhere.
	if(process.env.REACT_APP_OAUTH_ISSUER) return process.env.REACT_APP_OAUTH_ISSUER;
	if(host === 'auth.blackout.games' || host.indexOf('local.auth.') >= 0) {
		return window.location.origin;
	}
	return 'https://auth.blackout.games';
}

function captureCsrf(data) {
	if(data && data.csrf_token) csrfToken = data.csrf_token;
	csrfToken = csrfToken || readCookie(sessionCookieName);
}

async function request(method, path, { data, params, csrf = false } = {}) {
	let headers = { Accept: 'application/json' };
	if(data) headers['Content-Type'] = 'application/json';
	if(csrf) {
		captureCsrf();
		if(csrfToken) headers['X-CSRF-Token'] = csrfToken;
	}
	let response = await axios({
		method,
		url: `${issuer()}${path}`,
		data,
		params,
		headers,
		withCredentials: true,
	});
	captureCsrf(response.data);
	return response.data;
}

// Deliberately separate from BlackoutAPI: it never logs request bodies because
// this flow carries a password or a social-provider assertion to Blackout only.
export default {
	issuer,
	authorizationFormAction() { return `${issuer()}/oauth/authorize`; },
	getCsrf() { captureCsrf(); return csrfToken; },
	getSession(params) { return request('get', '/oauth/session', { params }); },
	login(data) { return request('post', '/oauth/session', { data, csrf: true }); },
	startProviderLogin(data) { return request('post', '/oauth/session/provider', { data, csrf: true }); },
	logout() { return request('delete', '/oauth/session', { csrf: true }); },
	getAuthorization(params) { return request('get', '/oauth/authorize', { params }); },
	getClients() { return request('get', '/oauth/clients'); },
	createClient(data) { return request('post', '/oauth/clients', { data, csrf: true }); },
	updateClient(id, data) { return request('patch', `/oauth/clients/${encodeURIComponent(id)}`, { data, csrf: true }); },
	deleteClient(id) { return request('delete', `/oauth/clients/${encodeURIComponent(id)}`, { csrf: true }); },
	rotateClientSecret(id) { return request('post', `/oauth/clients/${encodeURIComponent(id)}/rotate-secret`, { data: {}, csrf: true }); },
	getGrants() { return request('get', '/oauth/grants'); },
	revokeGrant(id) { return request('delete', `/oauth/grants/${encodeURIComponent(id)}`, { csrf: true }); },
};
